import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setObjectName } from '../../reducers/documentation/salesforceDocumentationReducer';
import { AgentSelectionType } from '../../types/enums/AgentType';
import { AgentContextSelectionModal } from './agent-selection/AgentContextSelectionModal';
import CreateMonitoringAgentDialog, { SELECTION_TYPES } from './CreateMonitoringAgentDialog';

export const CreateMonitoringAgentDialogWrapper = ({
  setIsNewMonitoringAgentDialogOpened,
  isNewMonitoringAgentDialogOpened,
  crmOrgId,
}: {
  setIsNewMonitoringAgentDialogOpened: (isOpen: boolean) => void;
  isNewMonitoringAgentDialogOpened: boolean;
  crmOrgId: string;
}) => {
  const dispatch = useDispatch();
  const [isAgentContextSelectionModalOpen, setIsAgentContextSelectionModalOpen] = useState(false);
  const [selectionData, setSelectionData] = useState<{
    selectionType: string;
    selectedObjectType?: string;
    selectedMetadataType?: string;
  } | null>(null);

  const handleCreateMonitoringAgentNext = useCallback(
    (data: {
      selectionType: string;
      selectedObjectType?: string;
      selectedMetadataType?: string;
    }) => {
      setSelectionData(data);
      setIsAgentContextSelectionModalOpen(true);
    },
    [],
  );

  const handleAgentContextSelectionModalClose = useCallback(() => {
    setIsAgentContextSelectionModalOpen(false);
    setSelectionData(null);
    // Clear documentation state when modal closes
    dispatch(setObjectName({ objectTypeName: undefined }));
    setIsNewMonitoringAgentDialogOpened(false);
  }, [dispatch, setIsNewMonitoringAgentDialogOpened]);

  return (
    <>
      {isNewMonitoringAgentDialogOpened && (
        <CreateMonitoringAgentDialog
          closeDialog={() => setIsNewMonitoringAgentDialogOpened(false)}
          onNext={handleCreateMonitoringAgentNext}
        />
      )}
      {isAgentContextSelectionModalOpen && selectionData && (
        <AgentContextSelectionModal
          isOpen={isAgentContextSelectionModalOpen}
          onClose={handleAgentContextSelectionModalClose}
          agentType={
            selectionData.selectionType === SELECTION_TYPES.OBJECT
              ? AgentSelectionType.OBJECT_TYPES
              : AgentSelectionType.METADATA_TYPES
          }
          objectType={
            selectionData.selectionType === SELECTION_TYPES.OBJECT
              ? selectionData.selectedObjectType
              : undefined
          }
          metadataType={
            selectionData.selectionType === SELECTION_TYPES.METADATA
              ? selectionData.selectedMetadataType
              : undefined
          }
          crmOrgId={crmOrgId ?? ''}
        />
      )}
    </>
  );
};
